import * as yup from 'yup'
import { InputValidationEnum } from 'enums'

export const ruCulture = 'ru-RU'
export const enCulture = 'en-US'
export const kgCulture = 'ky-KG'
export const tjCulture = 'tg-Cyrl-TJ'
export const swCulture = 'sw-TZ'

export function getCountryLangauges(countryId) {
  switch (countryId) {
    case null: // Not initialized
      return allLanguages

    case 1:
      return [allLanguages[0], allLanguages[1], allLanguages[2]]

    case 2:
      return [allLanguages[0], allLanguages[1], allLanguages[3]]

    case 3:
      return [allLanguages[0], allLanguages[4]]
  }
}

export function getLanguagesValidationSchema(countryId, intl, propertyName) {
  const shape = {}
  getCountryLangauges(countryId).forEach(el => {
    shape[propertyName + el.shortName] = yup
      .string()
      .typeError(intl.formatMessage({ id: 'validation.is_required' }))
      .required(intl.formatMessage({ id: 'validation.is_required' }))
      .matches(InputValidationEnum.NO_ONLY_SPACES, intl.formatMessage({ id: 'validation.not_valid' }))
  })

  return shape
}

export function getTranslationsList(data, initalData, propertyName) {
  const translations = []
  allLanguages.forEach(x => {
    let translation = undefined
    const prop = propertyName + x.shortName
    const idProp = `${prop}Id`

    if (prop in data) translation = data[propertyName + x.shortName]
    else if (initalData !== undefined && prop in initalData) translation = initalData[prop]

    if (translation !== undefined)
      translations.push({
        id: initalData !== undefined && idProp in initalData ? initalData[idProp] : 0,
        [propertyName]: translation,
        cultureName: x.culture,
      })
  })

  return translations
}

export function getLanguagesInitValues(translations, cellData, propertyName) {
  const languages = {
    kyrgyz: {},
    english: {},
    russian: {},
    tajik: {},
    kiswahili: {},
  }

  translations.forEach(el => {
    if (el.cultureName === 'ru-RU') {
      languages.russian = el
    } else if (el.cultureName === 'ky-KG') {
      languages.kyrgyz = el
    } else if (el.cultureName === 'en-US') {
      languages.english = el
    } else if (el.cultureName === 'tg-Cyrl-TJ') {
      languages.tajik = el
    } else if (el.cultureName === 'sw-TZ') {
      languages.kiswahili = el
    }
  })

  return {
    [`${propertyName}Ru`]: languages?.russian?.[propertyName] || cellData.name,
    [`${propertyName}RuId`]: languages?.russian?.id ?? 0,

    [`${propertyName}En`]: languages?.english?.[propertyName] || cellData.name,
    [`${propertyName}EnId`]: languages?.english?.id ?? 0,

    [`${propertyName}Kg`]: languages?.kyrgyz?.[propertyName] || cellData.name,
    [`${propertyName}KgId`]: languages?.kyrgyz?.id ?? 0,

    [`${propertyName}Tj`]: languages?.tajik?.[propertyName] || cellData.name,
    [`${propertyName}TjId`]: languages?.tajik?.id ?? 0,

    [`${propertyName}Sw`]: languages?.kiswahili?.[propertyName] || cellData.name,
    [`${propertyName}SwId`]: languages?.kiswahili?.id ?? 0,
  }
}

export const allLanguages = [
  {
    fullName: 'english',
    shortName: 'En',
    nativeName: 'English',
    culture: enCulture,
  },
  {
    fullName: 'russian',
    shortName: 'Ru',
    nativeName: 'Русский',
    culture: ruCulture,
  },

  {
    fullName: 'kyrgyz',
    shortName: 'Kg',
    nativeName: 'Кыргыз тили',
    culture: kgCulture,
  },
  {
    fullName: 'tajik',
    shortName: 'Tj',
    nativeName: 'Тоҷикӣ',
    culture: tjCulture,
  },
  {
    fullName: 'kiswahili',
    shortName: 'Sw',
    nativeName: 'Kiswahili',
    culture: swCulture,
  },
]
